














































































import { Component, Vue, Emit, PropSync, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
const common = namespace("common");
const credit = namespace("credit");

@Component
export default class CreditLimitAjustDialog extends Vue {
  @PropSync("visible", { type: Boolean, default: false })
  dialogVisible: boolean;

  @common.Action getMember;
  @credit.Action updateShopFinancialPassword;
  @credit.Action sendSms;
  private isSaveLoading = false;
  form: any = {
    phone: "",
    verifyCode: "",
    newPassword: "",
    confirmNewPassword: ""
  };
  passwordType1: any = true;
  passwordType2: any = true;
  second: any = 60;
  get rules() {
    return {
      verifyCode: [
        {
          required: true,
          message: "验证码不能为空",
          trigger: "blur"
        }
      ],
      newPassword: [
        { required: true, validator: this.validatePass, trigger: "blur" }
      ],
      confirmNewPassword: [
        { required: true, validator: this.validatePass2, trigger: "blur" }
      ]
    };
  }

  validatePass(rule, value, callback) {
    // 字母和数字，6位以上
    let pattern = /^[A-Za-z0-9]+$/;
    console.log(value, "value");
    if (value === "") {
      let error: any = "密码不能为空";
      callback(new Error(error));
    } else if (value.length < 6 || value.length > 20) {
      let error: any = "密码长度必须为6-20字符";
      callback(new Error(error));
    } else if (!pattern.test(value)) {
      let error: any = "密码需维护6位及以上的数字、字母";
      callback(new Error(error));
    } else {
      callback();
    }
  }
  validatePass2(rule, value, callback) {
    if (value === "") {
      let error: any = "密码不能为空";
      callback(new Error(error));
    } else if (value !== this.form.newPassword) {
      let error: any = "两次填写的密码不一致";
      callback(new Error(error));
    } else {
      callback();
    }
  }

  @Watch("visible")
  watchVisibleFn(val) {
    if (val) {
      // 初始化弹窗数据
    } else {
      let $form: any = this.$refs.form;
      $form && $form.resetFields();
    }
  }
  shopInfo: any = {};
  async created() {
    console.log("---getMember--created");
    // 获取导出项配置
    let memberCode = localStorage.getItem("memberCode");
    let memberType = localStorage.getItem("memberType");
    let marketType = localStorage.getItem("marketType");
    let res = await this.getMember({
      request: {
        memberCode,
        memberType,
        marketType,
        isExt: "2"
      }
    });
    this.shopInfo = res || {};
    this.form.phone = res.innerManageMobile;
    console.log(res, "---getMember");
  }

  triggerPassword(name) {
    this[name] = !this[name];
  }

  submit() {
    let $form: any = this.$refs.form;
    $form.validate(async val => {
      if (val) {
        let memberCode = localStorage.getItem("memberCode");
        let userInfo = JSON.parse(localStorage.getItem("userInfo"));
        let marketType = localStorage.getItem("marketType");
        let res = await this.updateShopFinancialPassword({
          shopCode: memberCode,
          categoryCode: marketType,
          financialPassword: this.form.newPassword,
          tenantCode: userInfo.tenantCode,
          phoneNumber: this.shopInfo.innerManageMobile,
          verificationCode: this.form.verifyCode
        });
        if (res) {
          this.$message.success("密码设置成功");
          this.dialogVisible = false;
        }
        // this.$emit("submit", this.form.total);
      }
    });
  }

  isSend: any = false;
  msgLoading: any = false;
  everSendMsg: any = false;
  async sendMsgFn() {
    if (this.msgLoading) return;
    try {
      this.msgLoading = true;
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      await this.sendSms({
        phone: this.shopInfo.innerManageMobile,
        tenantCode: userInfo.tenantCode
      });
      this.isSend = true;
      let info: any = "验证码发送成功";
      this.$message.success(info);
      this.timerOutFn();
      this.everSendMsg = true;
    } finally {
      this.msgLoading = false;
    }
  }
  timer: any = null;
  timerOutFn() {
    this.timer = setInterval(() => {
      if (this.second > 1) {
        this.second--;
        // localStorage.setItem("sendSec", this.second);
      } else {
        clearInterval(this.timer);
        // localStorage.removeItem("sendSec");
        this.second = 60;
        this.isSend = false;
        this.everSendMsg = false;
      }
    }, 1000);
  }
}
